import BaseService from "../BaseService";
import _ from "lodash";

class DahsboardReportService extends BaseService {
    dashboard = async (filter) => {
        var data = await this._api.post("/report/website/dashboard",filter);
        return data;
    };

   











}
export default DahsboardReportService;
